import { neloLogger } from '../utils'
import commonEng from './context/common/common_en.json'
import commonKor from './context/common/common_ko.json'
import reviewWriteEng from './context/reviewWrite/reviewWrite_en.json'
import reviewWriteKor from './context/reviewWrite/reviewWrite_ko.json'
import { langVar } from './translate.state'

const contexts = {
  reviewWrite: {
    ko: reviewWriteKor,
    en: reviewWriteEng,
  },
  common: {
    ko: commonKor,
    en: commonEng,
  },
}

const translate = <T extends keyof typeof contexts>({ contextType }: { contextType: T }) => {
  const lang = langVar()
  const context = contexts[contextType]
  const contextLang = context[lang]
  type Code = keyof (typeof context)['ko']

  const t = (code: Code) => {
    const value = contextLang?.[code as keyof typeof contextLang]

    if (value === undefined) {
      neloLogger('warn', `translate error label is undefined`, { lang, contextType, code })
    }

    return value ?? ''
  }

  const Translate = ({ code, className }: { code: Code; className?: string }) => {
    return <span className={className} dangerouslySetInnerHTML={{ __html: t(code) }}></span>
  }

  return { t, Translate }
}

export default translate
